var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomPhoneLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Phone",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 58.7991 58.7991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0b5cff;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -2888.64907,
    cy: -184.8774,
    fx: -2888.64907,
    fy: -184.8774,
    r: 2.09993,
    gradientTransform: "translate(54554.67285 2942.59042) scale(18.8757 15.7759)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#365cfa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#233ead"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -2888.61224,
    cy: -184.63298,
    fx: -2888.61224,
    fy: -184.63298,
    r: 2.09993,
    gradientTransform: "translate(54534.33582 2944.50313) scale(18.8689 15.7702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#365cfa",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80a2ed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.7991,29.39955c0,3.14386-.25199,6.22661-.73494,9.23251-1.596,9.95091-9.47087,17.83313-19.4247,19.43142-3.00307.48278-6.08996.73562-9.23991.73562s-6.21582-.25283-9.23991-.73562c-9.9328-1.59829-17.8287-9.48051-19.4247-19.43142-.48295-3.00589-.73494-6.08864-.73494-9.23251s.25199-6.22661.73494-9.23251C2.33094,10.21614,10.22683,2.33391,20.15964.73562c3.02409-.48278,6.08996-.73562,9.23991-.73562s6.23684.25283,9.23991.73562c9.95382,1.59829,17.8287,9.48051,19.4247,19.43142.48295,3.00589.73494,6.08864.73494,9.23251Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.7991,29.39955c0,3.14386-.25199,6.22661-.73494,9.23251-1.596,9.95091-9.47087,17.83313-19.4247,19.43142-3.00307.48278-6.08996.73562-9.23991.73562s-6.21582-.25283-9.23991-.73562c-9.9328-1.59829-17.8287-9.48051-19.4247-19.43142-.48295-3.00589-.73494-6.08864-.73494-9.23251s.25199-6.22661.73494-9.23251C2.33094,10.21614,10.22683,2.33391,20.15964.73562c3.02409-.48278,6.08996-.73562,9.23991-.73562s6.23684.25283,9.23991.73562c9.95382,1.59829,17.8287,9.48051,19.4247,19.43142.48295,3.00589.73494,6.08864.73494,9.23251Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M58.7991,29.39955c0,3.14386-.25199,6.22661-.73494,9.23251-1.596,9.95091-9.47087,17.83313-19.4247,19.43142-3.00307.48278-6.08996.73562-9.23991.73562s-6.21582-.25283-9.23991-.73562c-9.95382-1.59829-17.8287-9.48051-19.4247-19.43142-.48295-3.0061-.73494-6.08864-.73494-9.23251,0-3.14365.25199-6.22661.73494-9.23272C2.33094,10.21614,10.22683,2.3337,20.15964.73541,23.18373.25263,26.2496,0,29.39955,0s6.23684.25263,9.23991.73541c9.95382,1.59828,17.8287,9.48072,19.4247,19.43142.48295,3.00611.73494,6.08886.73494,9.23272Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M44.09933,35.8307v2.756c0,3.03046-2.45705,5.48553-5.48088,5.50843v.0042l-.02102-.00147-.02102.00147v-.0021c-13.16684-.02268-23.8556-10.68464-23.87662-23.84471,0-3.05251,2.45705-5.55273,5.52292-5.55273h2.75082c2.03716,0,3.69596,1.64533,3.69596,3.67494v2.15268c0,.97459-.39887,1.9095-1.09177,2.59871l-1.93206,1.92819c-.37811.38828-.52499.97775-.31505,1.48467,1.68008,4.02732,4.89283,7.24447,8.92486,8.9234.50397.21188,1.09202.07434,1.49089-.31457l1.91104-1.91559c.69315-.68921,1.63804-1.07644,2.60394-1.07644h2.16303c2.03691,0,3.67494,1.64533,3.67494,3.67494l.00002-.00002Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomPhoneLogo);
export default __webpack_public_path__ + "static/media/zoom-phone-logo.840d4ae0fc3361ccefb2788039f6a64a.svg";
export { ForwardRef as ReactComponent };